import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bottomside',
  templateUrl: './bottom-side.component.html',
  styleUrls: ['./bottom-side.component.scss']
})
export class BottomsideComponent implements OnInit {

  currentYear: number = new Date().getFullYear();

  constructor() {}

  ngOnInit(): void {}
}